export default {"src":"/_next/static/media/youtube-icon.e542b328.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};